export const TILESET_TYPE_ATTRIBUTE = 'attribute';
export const TILESET_TYPE_CROP = 'crop';

export type TilesetType =
  | typeof TILESET_TYPE_ATTRIBUTE
  | typeof TILESET_TYPE_CROP;

export interface TilesetKey {
  hexCode: string;
  label: string;
}

export interface Tileset {
  continuousKey: Nullable<TilesetKey[]>;
  description: string;
  discreteKey: Nullable<TilesetKey[]>;
  displayNames: string[];
  id: string;
  learnMoreUrl: Nullable<string>;
  name: string;
  type: TilesetType;
  zoomLevels: Nullable<number[]>;
}
